export enum PortalLayoutSection {
  HEADER = 'header',
  FOOTER = 'footer',
  SEARCH = 'search',
}
